import pickBy from "lodash/pickBy";
import omit from "lodash/omit";

/**
 * Return only the mutations indicated by the given options. Reference {@link useTableMutations} for all possible mutations.
 * If no options are specified, the returned object simply includes the data and if there is an error,
 * which is essentially excluding all operations for the table and making it read-only.
 *
 * @param mutations The mutations object returned by {@link useTable}/{@link useTableMutations}
 * @param options The options specifying which mutations to include/exclude. If omitted, no mutations are included (only the data and error state are included).
 *
 * @return {TableMutations} The filtered mutations object
 */
const READ_ONLY = { add: false, update: false, delete: false };
export const filterTableMutations = (mutations, options) => {
  if (!mutations) {
    console.error("Cannot filter an empty mutations object");
    return {};
  }

  // Start by selecting all of them
  let selectedMutations = pickBy(mutations, (value, key) => true);
  // Merge given options with default,
  // If options given is falsey, then this will just make the selection be read-only
  let selections = {
    ...READ_ONLY,
    ...options,
  };

  // Then remove based on the given options
  if (!selections.add) {
    selectedMutations = omit(selectedMutations, [
      "setRowsToCreate",
      "rowsToCreate",
      "addRows",
    ]);
  }
  if (!selections.update) {
    selectedMutations = omit(selectedMutations, [
      "setRowsToUpdate",
      "rowsToUpdate",
      "updateRows",
      "bulkUpdateRows",
    ]);
  }
  if (!selections.delete) {
    selectedMutations = omit(selectedMutations, [
      "setRowsToDelete",
      "rowsToDelete",
      "deleteRows",
    ]);
  }

  // If no mutations are selected, then make the table read-only by removing the data set/reset functions
  if (!selections.add && !selections.update && !selections.delete) {
    selectedMutations = omit(selectedMutations, [
      "setData",
      "resetData",
      "isProcessing",
    ]);
  }

  return selectedMutations;
};
